/**
 * @author 3173
 * @desc 系列化表单页面
 * @date 2020-09-23
 */
import React from "react";
import {connect} from "dva";
import {framework_tool, component_tool, utils_tool} from '../../../../tool'
import {WizTableForm, WizAuthority} from '../../../common'
import { formatAuth } from '@/utils/commonUtils'

let {WizContainer, modelUtils, WizAvatarUpload, ossFileUtils} = framework_tool
let {WizCard, WizSpin, WizForm, Wizmessage,WizTooltip,WizIcon} = component_tool
let {Session} = utils_tool

const categoryConfig = WizTableForm.Config.categoryInfo(this, {apiParams: {type: 7, state: 1}})

class SeriesDetail extends WizContainer {
  componentName = 'seriesDetail'

  constructor(props) {
    super(props)
    const {history} = props
    let initialValue = {}
    let cardTitle = '新增'
    if (history.location && history.location.pathname === '/series/seriesList/seriesDetailUpd') {
      if (history.location && history.location.record) {
        initialValue = history.location.record
        Session.set('seriesDetail', initialValue)
      } else {
        initialValue = Session.get('seriesDetail') || {}
      }
      cardTitle = '编辑'
    }
    this.initialValue = initialValue
    this.state = {
      cardTitle,
      time:"defKey"
    }
  }

  /**
   * ⭐ 只有路由配置时cached: true 才会有此生命周期, 且刷新逻辑需自行实现
   * 编辑时可能会触发重置,如果关键字id不同,则判定是新进入,将重新渲染表单
   */
  _componentDidRecover() {
    const { history } = this.props;
    let initialValue = {};
    if (history.location && history.location.pathname === '/series/seriesList/seriesDetailUpd') {
      if (history.location.record) {
        initialValue = history.location.record;
        Session.set('seriesDetail', initialValue)
      } else {
        initialValue = Session.get('seriesDetail') || {};
      }
    }
    if (initialValue.id != this.initialValue.id) {
      this.initialValue = initialValue
      this._componentDidMount()
    }
  }

  _componentDidMount() {
    if (this.initialValue.id) {
      this.doAction({
        path: 'series/getSeriesInfo',
        payload: {
          key: 'getSeriesInfo',
          apiParams: {
            id: this.initialValue.id
          }
        }
      })
    }
  }

  propsAndStateOnChange = {
    saveSeries: this._saveSeriesOver.bind(this),
    getSeriesInfo: this._getSeriesInfoOver.bind(this)
  }

  _getSeriesInfoOver(nextProps, nextState) {
    if (nextProps.getSeriesInfo.code == 1) {
      this.initialValue = nextProps.getSeriesInfo.data;
      nextState.time = new Date().getTime();
    }
    return true;
  }

  _saveSeriesOver(nextProps, nextState) {
    if (nextProps.saveSeries.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replaceAndDelCrumb', '/series/seriesList');
    } else {
      wizNotice.error('提交失败：' + nextProps.saveSeries.msg);
    }
    return true;
  }

  /**
   * 过滤字段值为undefined&null的字段
   * @param {Object} fieldsValue
   */
  fitterFieldsValue(fieldsValue) {
    let fitterValues = {};
    Object.keys(fieldsValue).forEach(key => {
      const value = fieldsValue[key];
      if (value != null && value != undefined) {
        fitterValues[key] = value;
      }
    });

    let columnImg = fitterValues['columnImg']
    if (columnImg && columnImg.length) {
      fitterValues['img'] = columnImg[0]['fileId']
      delete fitterValues['columnImg']
    }

    // let authCmd = {}
    // if (fitterValues['authCmd']) {
    //   let authInfo = fitterValues['authCmd']
    //   authCmd.isAll = authInfo.isAll
    //   authCmd['orgIds'] = authInfo['orgIds'] && authInfo['orgIds'].map(p => (p.id))
    //   authCmd['positionIds'] = authInfo['positionIds'] && authInfo['positionIds'].map(p => (p.id))
    //   authCmd['positionCategoryIds'] = authInfo['positionCategoryIds'] && authInfo['positionCategoryIds'].map(p => (p.id))
    //   authCmd['personIds'] = authInfo['personIds'] && authInfo['personIds'].map(p => (p['id']))
    // }
    // fitterValues['authCmd'] = authCmd

    fitterValues.authCmd = formatAuth(fitterValues.authCmd)

    return fitterValues;
  }

  _sumbit(values) {
    const {history} = this.props
    let apiPath = 'series/add';
    if (history.location && history.location.pathname === '/series/seriesList/seriesDetailUpd') {
      apiPath = 'series/update'
    }
    let fitterValues = this.fitterFieldsValue(values)
    this.doAction({
      path: apiPath,
      payload: {
        key: 'saveSeries',
        apiParams: {...fitterValues,id:this.initialValue.id,categoryId:this.initialValue.categoryId}
      }
    })
  }

  _render() {
    const {seriesLoading} = this.props
    const {cardTitle} = this.state
    let initialValue = this.initialValue
    let columns = [
      {
        name: 'id',
        formItem: {
          type: 'hidden',
          initialValue: initialValue.id
        }
      },
      {
        title: '名称',
        name: 'name',
        formItem: {
          maxLength: 20,
          placeholder: '名称最多输入20个字',
          initialValue: initialValue.name,
          rules: [
            {
              required: true,
              message: '请输入名称'
            },
            {
              pattern: /^[\u4e00-\u9fa5a-zA-z0-9\.\-\[\]_·]*$/,
              message: '名称只能包含中文、英文、数字、[、]、-、_、.、·'
            }
          ],
        }
      },
      {
        title: <span>
                  封面&nbsp;
                  <WizTooltip title="请上传大小不超过200KB,图片尺寸建议800*450">
                      <WizIcon type="question-circle-o" />
                  </WizTooltip>
                </span>,
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const {getFieldDecorator} = form
            return (
              <>
                {getFieldDecorator('columnImg', {
                  rules: [
                    {
                      required: true,
                      message: '请上传封面'
                    }
                  ],
                  initialValue: (initialValue && initialValue.img) ? [
                    // ossFileUtils.getOssFile(
                    //   initialValue.img, initialValue.fileName, initialValue.fileMimeType, initialValue.fileSize, initialValue.fileUri,
                    // )
                    {fileId:initialValue.img}
                  ] : [],
                })(
                  <WizAvatarUpload
                    accept={'.jpg, .jpeg, .png'}
                    listType={'picture-card'}
                    aspectRatio={80 / 45}
                    beforeUpload={(file) => {
                      const isLt1M = file.size / 1024 / 1024 < 0.195;
                      if (!isLt1M) {
                        Wizmessage.error('图片不得超过200k!');
                      }
                      return isLt1M;
                    }}
                  />
                )}
              </>
            )
          }
        },
      },
      {
        title: '简介',
        name: 'intro',
        formItem: {
          maxLength: 200,
          placeholder: '简介最多输入200个字',
          type: 'textarea',
          initialValue: initialValue.intro
        }
      },
      {
        title: '分类',
        name: 'seriesCategoryIds',
        formItem: {
          ...categoryConfig,
          diy: WizTableForm,
          initialValue: initialValue.seriesCategoryIds,
          initRows: initialValue.categoryInfo ? initialValue.categoryInfo : [],//{id: initialValue.categoryId, name: initialValue.categoryName}
          rules: [ {
            required: true,
            message: '请选择分类'
          } ],
        }
      },
      {
        title: '类型',
        name: 'type',
        dict: [
          {code: 0, codeName: '系列'},
          {code: 1, codeName: '课程组'}
        ],
        formItem: {
          initialValue: initialValue.type,
          type: 'select',
          rules: [
            {required: true, message: '请选择类型'}
          ],
        },
      },
      {
        title: '受众',
        name: 'authCmd',
        formItem: {
          type: 'diy',
          diy: WizAuthority,
          rules: [
            {
              required: true,
              message: '请选择受众'
            }
          ],
          initialValue: initialValue.authData,
          showBlock: false,
          keys: ['orgIds', 'positionIds', 'positionCategoryIds', 'personIds'],
          keyConfig:{
            // orgIds: {
            //   title: '品牌选择',
            //   config: WizTableForm.Config.organization(this, { apiParams: { state: 1, organizationNodeCategory: ["2"] } })
            // }
          },
          //mode:'Form'
        }
      },

      {
        title: '状态',
        name: 'state',
        formItem: {
          initialValue: initialValue.state != null ? initialValue.state : 1,
          type: 'radio'
        },
        dict: [
          {code: 1, codeName: '有效'},
          {code: 0, codeName: '无效'}
        ]
      },
    ]

    let onSubmit = this._sumbit.bind(this)

    let formProps = {
      ref: 'form',
      key: this.initialValue.id || '', // ⭐如缓存路由需要刷新,必须加标识key
      columns,
      onSubmit,
      record: null,
      preview: null,
      footer: undefined,
      formItemLayout: {
        labelCol: {span: 4},
        wrapperCol: {span: 17}
      }
    }

    return (
      <WizCard>
        <WizSpin tip={'加载中'} spinning={seriesLoading}>
          <WizForm key={this.state.time} className={'form-inline'} {...formProps} />
        </WizSpin>
      </WizCard>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {series} = state;
  const saveSeries = modelUtils.getModelEntity(series, 'saveSeries');
  const getSeriesInfo = modelUtils.getModelEntity(series, 'getSeriesInfo');
  const load = modelUtils.getLoadingState(state, 'series');
  return {
    saveSeries,
    getSeriesInfo,
    ...load
  }
}

export default connect(mapStateToProps)(SeriesDetail);

